export enum InvoiceStatus {
  IN_PROGRESS = "In progress",
  FUNDS_CLEARED = "Funds cleared",
  ERROR = "Error",
  REFUNDED = "Refunded",
}
